/* eslint-disable consistent-return */
import { ELEMENT_PARAGRAPH } from '@doltech/utils/lib/constants';
import { isNil } from 'lodash';
import { Transforms } from 'slate';
import { ReactEditor } from 'slate-react';

import { SlatePlugin } from '../../../slatePlugins/slatePlugins.types';
import { deserializeParagraph, deserializeParagraphWithoutHeading } from './shared-transforms';

interface DivPluginOptions {
  headingEnabled?: boolean;
}

export const DivPlugin = (options: DivPluginOptions): SlatePlugin => {
  if (options.headingEnabled) {
    return {
      deserialize: {
        element: [
          {
            type: 'div',
            deserialize: deserializeParagraphWithoutHeading,
          },
        ],
      },
    };
  }

  return {
    deserialize: {
      element: [
        {
          type: 'div',
          deserialize: deserializeParagraph,
        },
      ],
    },
  };
};

export const withDivEditorChains =
  () =>
  <T extends ReactEditor>(editor: T) => {
    const { normalizeNode } = editor;

    editor.normalizeNode = (entry) => {
      const [node, path] = entry as [any, any[]];

      if (node?.type === 'div') {
        const firstChild = node?.children?.[0];
        if (!isNil(firstChild.text) && !isNil(firstChild.marks)) {
          Transforms.removeNodes(editor, { at: path });
          return;
        }
        if (firstChild?.type === 'div') {
          Transforms.unwrapNodes(editor, { at: [...path, 0] });
          return;
        }
        Transforms.setNodes(editor, { type: ELEMENT_PARAGRAPH }, { at: path });
        return;
      }

      if (node?.type === ELEMENT_PARAGRAPH) {
        const isParagraphInsideParagraph = node.children.some((n) => n?.type === ELEMENT_PARAGRAPH);
        if (isParagraphInsideParagraph) {
          const paragraphIndex = node.children.findIndex((n) => n?.type === ELEMENT_PARAGRAPH);
          Transforms.liftNodes(editor, { at: [...path, paragraphIndex] });
          return;
        }
      }

      normalizeNode(entry);
    };

    return editor;
  };
